/* globals request */
import _ from 'lodash';
import UtilsHelper from '../utils/utils-helper';

export default class BaseHelper {
  request = (baseUrl, {
    method = 'GET',
    auth = 'Bearer',
    body = null,
    filter,
    perPage,
    page,
    orderBy,
    flags,
    q,
    ...restProps
  }) => {
    let getParamsStr = '';
    const objGetParams = {};

    if (!_.isEmpty(filter)) {
      objGetParams.filter = filter;
    }
    if (!_.isEmpty(orderBy)) {
      objGetParams.orderBy = orderBy;
    }
    if (perPage) {
      objGetParams.perPage = perPage;
    }
    if (page) {
      objGetParams.page = page;
    }
    if (flags) {
      objGetParams.flags = flags;
    }
    if (q) {
      objGetParams.q = q;
    }
    if (!_.isEmpty(objGetParams)) {
      getParamsStr = UtilsHelper.serialize(objGetParams, '?');
    }
    return request(`${baseUrl}${getParamsStr}`, {
      method,
      auth,
      body,
      ...restProps,
    });
  }
}
